import { Outlet, createFileRoute } from '@tanstack/react-router';
import { requireInternalOrganisation } from '@/lib/staffGate.ts';

/*
 * The tools that only make sense from inside Wundo. Superadmin got you into the
 * console; an internal organisation is the inner door, exactly as it was in the
 * Vue router's `requiresSuperadminInternal`.
 *
 * The list of tools is not here: it is the Admin group's own, drawn beside the
 * content by the shell like every other group's. This route is the gate.
 */
export const Route = createFileRoute('/_app/admin')({
  beforeLoad: ({ context }) => requireInternalOrganisation(context.queryClient),
  component: Outlet,
});
